import { useMutation } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import {
  CURRENT_ENTITY_QUERY_KEY,
  USER_ENTITIES_QUERY_KEY,
} from '@/modules/entity/queries/entity.tsx';
import { CURRENT_SHAREHOLDER_COMMUNICATION_QUERY_KEY } from '@/modules/investor-dashboard/queries/shareholders.tsx';
import { NOTIFICATIONS_LIST_QUERY_KEY } from '@/modules/issuer-dashboard/queries/event-logs.ts';
import { UpdateEntityPaymentAndContactDetailsRequest } from 'api';

export const SHOW_MODAL_COMPLETE_KYC = 'vestra/showModalCompleteKYC';

export const useUpdateEntityContactPaymentDetailsMutation = ({
  onSuccess,
}: { onSuccess?: () => void } = {}) => {
  return useMutation({
    mutationFn: async (payload: UpdateEntityPaymentAndContactDetailsRequest) => {
      const response = await withErrorHandling(
        api.v1.updateEntityContactPaymentDetailsV1SrEntitiesContactPaymentDetailsPatch(payload),
        {
          loading: 'Updating settings...',
          success: 'Settings updated',
        },
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([CURRENT_SHAREHOLDER_COMMUNICATION_QUERY_KEY]);
      await queryClient.invalidateQueries([USER_ENTITIES_QUERY_KEY]);
      await queryClient.invalidateQueries([NOTIFICATIONS_LIST_QUERY_KEY]);
      await queryClient.invalidateQueries([CURRENT_ENTITY_QUERY_KEY]);

      onSuccess && onSuccess();
    },
  });
};
